import { getUrlObject } from '../url/getUrlObject';

interface CloudinaryOptions {
	cloudName?: string;
	proxyDomain?: string;
}

/**
 * Transform the URL of the Cloudinary asset to retrieve it from the proxy domain
 *
 * **Example**
 *
 * ```
 * getCloudinaryAssetProxyUrl(
 *   'https://res.cloudinary.com/takeda/image/...',
 *   {
 *     proxyDomain: 'assets-dam.takeda.com',
 *     cloudName: 'takeda',
 *   }
 * );
 * // ⤷ "https://assets-dam.takeda.com/image/..."
 * ```
 */
export const getCloudinaryAssetProxyUrl = (
	cloudinaryUrl: string,
	cloudinaryOptions?: CloudinaryOptions,
) => {
	const url = getUrlObject(cloudinaryUrl);

	if (!url) return '';

	if (!cloudinaryOptions) return cloudinaryUrl;

	const { cloudName, proxyDomain } = cloudinaryOptions;

	if (proxyDomain) {
		url.host = proxyDomain;

		if (cloudName && url.pathname.startsWith(`/${cloudName}/`)) {
			url.pathname = url.pathname.slice(cloudName.length + 1);
		}
	}

	return url.toString();
};
